export default __webpack_public_path__ + "static/media/certlayout_manila.a31768a4.png";